import { Edit, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import BackButtonToolbar from "features/BackButtonToolbar";

const EditAcademicYear = () => {
  return (
    <Edit
      title="Редакция на академична година"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm />
      </SimpleForm>
    </Edit>
  );
};
export default EditAcademicYear;
